// eslint-disable-next-line import/prefer-default-export
export const WUJIE_EVENT_NAME = {
  'INJECT_LOGIN_DATA' : 'INJECT_LOGIN_DATA',
  'JUMP_TO_SUB_ROUTE': 'JUMP_TO_SUB_ROUTE', // 共用实例，发送路由到子应用，子应用自己跳转
  'CLOSE_MAIN_ROUTE': 'CLOSE_MAIN_ROUTE', // 关闭主应用Tab路由事件，同城
  'SUBAPP_SESSION_EXPIRE': 'SUBAPP_SESSION_EXPIRE', // 子应用session过期
  'INJECT_WORKBENCH_DATA': 'INJECT_WORKBENCH_DATA', // 向子应用注入工作台数据
  'SET_TASK_VISIBLE': 'SET_TASK_VISIBLE', // 子应用发事件给主应用展示顶部导入导出提示
}
